import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse } from "axios";
import { getCookie, removeCookie, setCookie } from "./Cookie";
import envUtil from "./envUtil";

class AxiosSetting {
  #TIME_OUT_MILLISECOND = 60 * 1000;
  #token?: string;
  #instance: AxiosInstance;

  constructor(baseURL: string) {
    this.#token = getCookie({ name: "token" }) || undefined;
    const tokenCheck = async () => {};
    tokenCheck();
    this.#instance = axios.create({
      baseURL,
      timeout: this.#TIME_OUT_MILLISECOND,
    });
    this.#instance.interceptors.request.use((value) => {
      return value;
    });
  }

  getToken() {
    return this.#token;
  }

  async setToken(_token: string) {
    this.#token = _token;

    await setCookie({ name: "token", value: _token });
  }

  deleteToken() {
    this.#token = undefined;
    removeCookie({ name: "token" });
  }

  getInstance() {
    return this.#instance;
  }
}

class Api {
  #baseURL: string;
  #api: AxiosInstance;

  getToken: () => string | undefined;

  setToken: (token: string) => void;

  deleteToken: () => void;

  constructor() {
    this.#baseURL = envUtil.API_URL;

    const apiUtil = new AxiosSetting(this.#baseURL);
    this.#api = apiUtil.getInstance();
    this.getToken = () => apiUtil.getToken();
    this.setToken = (token) => apiUtil.setToken(token);
    this.deleteToken = () => apiUtil.deleteToken();
  }

  post<T = any, R = AxiosResponse<T>, D = any>(
    url: string,
    data?: D,
    config?: AxiosRequestConfig<D>
  ): Promise<R> {
    return this.#api.post(url, data, config);
  }
}
export const api = new Api();

export const fetcher = <T = any, D = any>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>
): Promise<IResponse<T>> => {
  const requestConfig: AxiosRequestConfig = config ?? {};
  const token = api.getToken();
  const reqData: D | AnyObject = data || {};
  if (reqData instanceof FormData) {
    requestConfig.headers = { "Content-Type": "multipart/form-data" };
    reqData.append("token", String(token));
  }
  if (typeof reqData === "object" && token) {
    reqData.token = token;
  }
  const isEmptyObject =
    typeof reqData === "object" && Object.keys(reqData).length === 0;
  return api
    .post(url, isEmptyObject ? undefined : reqData, requestConfig)
    .then((res) => {
      const { data: resData }: { data: IResponse<T> } = res ?? {};
      if (res.status !== 200) {
        const error = new Error("An error occurred while fetching the data.");
        if (resData) {
          error.message = resData.message;
        } else {
          error.message = JSON.stringify(res);
        }
        throw error;
      } else if (!resData.success) {
        const error = new Error("An error occurred while fetching the data.");
        error.message = resData.message;
        // throw error;
      }
      return res.data;
    });
};

export async function post<T = any, D = any>(
  url: string,
  data?: D,
  config?: AxiosRequestConfig<D>
): Promise<IResponse<T>> {
  const requestConfig: AxiosRequestConfig = config ?? {};
  const token = api.getToken();
  const reqData: D | AnyObject = data || {};
  if (reqData instanceof FormData) {
    requestConfig.headers = { "Content-Type": "multipart/form-data" };
    reqData.append("token", String(token));
  }
  if (typeof reqData === "object") {
    reqData.token = token;
  }
  const res = await api.post(url, reqData, requestConfig);
  const { data: resData }: { data: IResponse<T> } = res ?? {};
  if (res.status !== 200) {
    const error = new Error("An error occurred while fetching the data.");
    if (resData) {
      error.message = resData.message;
    } else {
      error.message = JSON.stringify(res);
    }
    if (
      !["잘못된 사용자 입니다.", "잘못된 토큰입니다."].includes(error.message)
    ) {
      throw error;
    }
  } else if (!resData.success) {
    const error = new Error("An error occurred while fetching the data.");
    error.message = resData.message;
    throw error;
  }
  return res.data;
}
export const setToken = api.setToken;
export const getToken = api.getToken;

export const deleteToken = api.deleteToken;
